"use client"
import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '../../redux/store';
import {
    LOGIN_STATE_KEY,
    SH_TITLE,
    THEME,
    THEME_DARK,
    THEME_LIGHT,
    THEME_STATE_KEY,
    TOKEN
} from '../../services/CONSTANTS';
import {getLastTab, saveLoginParams} from '../../services/localStorage.service';
import ReactGA from 'react-ga4';
import {BUTTON_CLICK, BUTTON_CLICK_BACK} from '../../analytics/CONSTANTS';
import {toPersianNumber} from '../../utils/number.utils';

import LayoutDrawer from '../layoutDrawer.component';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Breadcrumbs, SwipeableDrawer} from '@mui/material';
import {motion} from 'framer-motion';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {NextSeo} from 'next-seo';
import {useTranslations} from "use-intl";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import useLocalStorage from "@/core/utils/localStorage";
import {loginState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE} from "@/core/reducer/CONSTANTS";
import {FavoriteDatabaseHelper} from "@/core/widget/favorite/database/favorite.database.helper";
import {ComponentService} from "@/core/general/container/service/component.service";
import {containerStateChange} from "@/core/reducer/containerReducer";
import {showInfoMessage, showSuccessMessage} from "@/core/reducer/messageReducer";
import {GAME_KEY, HOME_KEY, STORE_KEY, TOOLS_KEY, VIDEO_KEY} from "@/core/CONSTANTS";
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {TitleImageRowComponent} from "@/core/general/titleImageRowComponent";
import {FINANCIAL_HISTORY, NEWS, WALLET} from "@/core/navigation/CONSTANTS";
import {BackIconComponent} from "@/core/general/backIcon.component";
import {USER_FAVORITE_FULL_IMAGE, USER_FAVORITE_IMAGE, USER_SETTING_IMAGE} from "@/core/tools/profile/CONSTANTS";

interface containerProps {
    hasResponsivePadding?: boolean;
    onSettingClick?: ()=>void;
}

export const ContainerDetailComponent: FC<PropsWithChildren<containerProps>> = (props) => {
    const router = useRouter();
    const t = useTranslations();
    const searchParams = useSearchParams()
    const dispatch = useDispatch<AppDispatch>();
    const [resultOpen, setResultOpen] = useState(false);
    const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
    const [hasToolbar, setHasToolbar] = useState(false);
    const [pageImage, setPageImage] = useState<string>();
    const [pageTitle, setPageTitle] = useState<string>();
    const [shortcutFavoriteExist, setShortcutFavoriteExist] = useState(false);
    const pathname = usePathname()

    const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
    const shState = useAppSelector((state) => state.shortcutReducer);
    const containerState = useAppSelector((state) => state.containerReducer);
    const favHelper = new FavoriteDatabaseHelper();
    const [isDark, setDark] = useLocalStorage<boolean>(THEME_STATE_KEY, false);
    const [mainTab, setMainTab] = useState(true);

    useEffect(() => {
        if (shState && shState.item) {
            favHelper.getFavoriteItem(shState.item.id).then((fav) => {
                if (fav && fav.id) {
                    setShortcutFavoriteExist(true);
                }
            });
        }
    }, [shState]);

    function checkMainTabs():boolean{
        return pathname=="/"|| pathname.replace("/","").trim()==(HOME_KEY) || pathname.replace("/","").trim()==(STORE_KEY) || pathname.replace("/","").trim()==(TOOLS_KEY) || pathname.replace("/","").trim()==(VIDEO_KEY) || pathname.replace("/","").trim()==(GAME_KEY);
    }

    useEffect(() => {
        if (searchParams.get(TOKEN)) {
            const componentService = new ComponentService();
            componentService.getPrimaryToken(searchParams.get(TOKEN)?.toString() ?? '').subscribe((data) => {
                if (data && data.data && data.data.access) {
                    setLogin(true);
                    saveLoginParams(data.data.access, data.data.refresh, '', data.data.user_id);
                    dispatch(loginState({state: LOGIN_STATE, openLoginPage:false}));
                }
                //TODO sajad
                // router.query.delete(TOKEN);
                router.replace(searchParams.toString());
            });
        }
        if (searchParams.get(THEME)) {
            if (searchParams.get(THEME)?.toString() == THEME_DARK) {
                const root = document.documentElement;
                root.classList.remove('dark');
                root.classList.add('dark');
                document.cookie = `theme=${'dark'}; path=/; max-age=31536000`;
                setDark(true);
            } else if (searchParams.get(THEME)?.toString() == THEME_LIGHT) {
                const root = document.documentElement;
                root.classList.remove('light');
                root.classList.add('light');
                document.cookie = `theme=${'light'}; path=/; max-age=31536000`;
                setDark(false);
            }
        }
        //TODO fix language

        // if (searchParams.get(LANGUAGE)) {
        //     if (searchParams.get(LANGUAGE)?.toString() == ENGLISH) {
        //         saveAppLanguage(ENGLISH);
        //         i18n.changeLanguage(ENGLISH);
        //     } else if (searchParams.get(LANGUAGE)?.toString() == PERSIAN) {
        //         saveAppLanguage(PERSIAN);
        //         i18n.changeLanguage(PERSIAN);
        //     } else if (searchParams.get(LANGUAGE)?.toString() == ARABIC) {
        //         saveAppLanguage(ARABIC);
        //         i18n.changeLanguage(ARABIC);
        //     } else if (i18n.language === ENGLISH) {
        //         saveAppLanguage(ENGLISH);
        //         i18n.changeLanguage(ENGLISH);
        //     }
        // } else {
        //     if (getAppLanguage() === ENGLISH) {
        //         if (i18n.language != ENGLISH) {
        //             i18n.changeLanguage(ENGLISH);
        //         }
        //     }
        // }
        if (searchParams.get(SH_TITLE)) {
            if (pathname.includes("/t/")) {
                if (pathname.split("/t/").length > 1) {
                    setPageImage(`https://tlbx.ir/image/png_ic_${pathname.split("/t/")[1].split("/")[0]}.png`)
                }
            }
            setPageTitle(searchParams.get(SH_TITLE)?.toString() as string);
            setHasToolbar(true);
            //TODO sajad
            // props.onHasToolbar?props.onHasToolbar(true):null
        }
        setMainTab(checkMainTabs())
    }, [searchParams]);

    function backButtonClick() {
        return () => {
            dispatch(containerStateChange(""));
            ReactGA.event({
                category: BUTTON_CLICK,
                action: BUTTON_CLICK_BACK
            });
            if (pathname.includes(FINANCIAL_HISTORY + '/')) {
                router.replace(WALLET+`?shTitle=${t('payReceipt')}`);
            } else {
                router.replace(`/${getLastTab()}`);
            }
        };
    }

    function appBackButtonClick() {
        if (pathname.includes(FINANCIAL_HISTORY + '/')) {
            router.replace(WALLET+`?shTitle=${t('payReceipt')}`);
        } else if (pathname.includes(NEWS)) {
            if (pathname.includes("post")) {
                if (pathname.includes("selected")) {
                    router.replace(NEWS+ hasToolbar?`?shTitle=${t('shName.news')}`:"");
                } else {
                    router.replace(pathname.split("post")[0]+hasToolbar?`?shTitle=${t('shName.news')}`:"");
                }
            } else {
                router.back();
            }
        } else {
            router.back();
        }
    }

    function addToolToFavorite() {
        setShortcutFavoriteExist(true);
        if(shState.item){
            favHelper.addFavoriteItem(shState.item, false);
            dispatch(showSuccessMessage(t('fav.addToFavorite')));
        }
    }

    function removeToolFromFavorite() {
        setShortcutFavoriteExist(false);
        if(shState.item) {
            favHelper.deleteFavoriteItem(shState.item.id, true);
            dispatch(showInfoMessage(t('fav.deleteFromFavorite')));
        }
    }

    function middleRouteClick() {
        dispatch(containerStateChange(""));
        appBackButtonClick()
    }

    const variants = {
        show: {
            opacity: 1,
            x: 0,
            transition: {
                ease: 'easeOut',
                duration: 0.3
            }
        },
        hide: {
            x: 50,
            opacity: 0
        }
    };

    function getTabName() {
        switch (getLastTab()) {
            case HOME_KEY:
                return t('main')
            case TOOLS_KEY:
                return t('tools')
            case STORE_KEY:
                return t('store')
            case VIDEO_KEY:
                return t('videoPlus')
            case GAME_KEY:
                return t('game')
            default:
                return t('main')
        }
    }

    function getRouterPath() {
        let routeBase = "test";
        if (pathname.includes("/t/")) {
            if (pathname.split("/t/").length > 1) {
                routeBase = pathname.split("/t/")[1].split("/")[0];
            }
        }
        return routeBase;
    }

    return (
        <div className={"bgMain flex flex-col w-full h-full overflow-hidden"}>
                {!pathname.includes("/post/")?<NextSeo
                    title={pageTitle ?? `${t('appName')}`}
                    // description={t.raw(`shDesc.${getRouterPath()}`)==`shDesc.${getRouterPath()}` ? t(`shDesc.${getRouterPath()}`) : t('appDesc')}
                    openGraph={{
                        type: 'website',
                        locale: 'fa_IR',
                        url: 'https://tlbx.ir/',
                        siteName: t('appName'),
                        images: [
                            {
                                url: pageImage ?? 'https://tlbx.ir/icon.png',
                                width: 192,
                                height: 192,
                                type: 'image/png'
                            }
                        ],
                    }}
                    themeColor={'#000'}
                />:null}
                {hasToolbar ? (
                    <div
                        className={`flex flex-row mainToolbar py-2 center bgMain z-80 sticky ${hasToolbar?"top-0":"top-8"} md:top-14 px-2`}
                        style={{caretColor: 'transparent'}}
                    >
                        <Breadcrumbs
                            className={`w-full px-2 hidden md:block z-80 font`}
                            separator={<NavigateBeforeIcon fontSize="small" className={"mText"}/>}
                            aria-label="breadcrumb"
                        >
                            <div className={'text-bold pointer mText'} onClick={backButtonClick()}>
                                {getTabName()}
                            </div>
                            {containerState.state ? (
                                <motion.div
                                    initial={'hide'}
                                    animate={'show'}
                                    exit={'hide'}
                                    variants={variants}
                                    className={'flex flex-col items-center'}
                                    transition={{
                                        type: 'spring',
                                        damping: 20,
                                        stiffness: 250,
                                        duration: 1
                                    }}
                                >
                                    <div className={'text-bold pointer'} onClick={() => middleRouteClick()}>
                                        {containerState.state}
                                    </div>
                                </motion.div>
                            ) : null}
                            <div className="mText text-lg text-ellipsis max-h-8 mTextBlue grow overflow-hidden">
                                {toPersianNumber(pageTitle ?? "")}
                            </div>
                        </Breadcrumbs>
                        <div className={"totalCenter flex-row w-full flex md:!hidden z-30"}>
                            <BackIconComponent onClick={() => appBackButtonClick()}/>
                            <div
                                className="mText text-lg text-ellipsis max-h-8 text-bold px-1 mTextBlue grow overflow-hidden">{toPersianNumber(pageTitle ?? "")}</div>
                        </div>
                        {shState && shState.item ?
                            <MoreVertIcon className="mx-2 pointer" onClick={() => setResultOpen(true)}/> : null}
                    </div>
                ) : null}
                <div
                    className={`fade items-center overflow-scroll hideScrollBar ${hasToolbar?"pt-0 md:pt-14 h-[calc(100vh_-_3rem)] md:h-[calc(100vh_-_4rem)]":((mainTab?"pt-16":"pt-0")+" h-screen md:h-[calc(100vh_-_3rem)] ")} ${
                        props.hasResponsivePadding ? 'containerFullWidth' : 'w-full'
                    }`}>
                    {props.children}
                </div>
                <SwipeableDrawer
                    anchor={'bottom'}
                    open={resultOpen}
                    disableSwipeToOpen={true}
                    PaperProps={{square: false, elevation: 0, style: {backgroundColor: 'transparent'}}}
                    onOpen={() => setResultOpen(true)}
                    onClose={() => setResultOpen(!resultOpen)}
                >
                    <LayoutDrawer>
                        <Column>
                            <Row className="p-1 totalCenter mt-5">
                                {shortcutFavoriteExist ? (
                                    <TitleImageRowComponent
                                        onClick={() => removeToolFromFavorite()}
                                        title={t('removeFromFavorite')}
                                        image={USER_FAVORITE_FULL_IMAGE}
                                    />
                                ) : (
                                    <TitleImageRowComponent
                                        onClick={() => addToolToFavorite()}
                                        title={t('addToFavorite')}
                                        image={USER_FAVORITE_IMAGE}
                                    />
                                )}
                            </Row>
                            {shState ? (
                                <Row className={"w-full"} onClick={()=> setResultOpen(false)}>
                                    <TitleImageRowComponent onClick={props.onSettingClick} title={t('setting')} image={USER_SETTING_IMAGE}/>
                                </Row>
                            ) : null}
                        </Column>
                    </LayoutDrawer>
                </SwipeableDrawer>

            </div>
    );
};
